import React from 'react';
import Navbar from './navbar';
import HeroSection from './hero_section';
import VisionMission from './vision_and_mission';
import AllEvents from './all_events';
import Videos from './videos';
import Testimonials from './testimonials';
import Footer from './footer';
import './home.css';
function Home() {
  return (
    <div className="scale">
      <Navbar></Navbar>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <HeroSection></HeroSection>
        <VisionMission></VisionMission>
        <AllEvents></AllEvents>
        <Videos></Videos>
        <Testimonials></Testimonials>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default Home;
